import React, { useState, createContext, useContext } from 'react';
interface QuoteModalContextType {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}
const QuoteModalContext = createContext<QuoteModalContextType | undefined>(undefined);
export function QuoteModalProvider({
  children
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  return <QuoteModalContext.Provider value={{
    isOpen,
    openModal,
    closeModal
  }} data-id="element-494">
      {children}
    </QuoteModalContext.Provider>;
}
export function useQuoteModal() {
  const context = useContext(QuoteModalContext);
  if (context === undefined) {
    throw new Error('useQuoteModal must be used within a QuoteModalProvider');
  }
  return context;
}